( function( $ ) {
    var IdrogenoFullScreenPanelClass = {};
    IdrogenoFullScreenPanelClass.run = function(panelInstance){
        // private variables
        var thisFullScreenPanel = $(panelInstance);
        if (!$(thisFullScreenPanel).hasClass("ssnail-fullscreen-panel")) {
            thisFullScreenPanel = $(panelInstance).closest(".ssnail-fullscreen-panel");
        }

        // private methods
        var toggle = function() {
            if (thisFullScreenPanel.hasClass('open')) {
                close();
            } else {
                open();
            }
        };
        var open = function() {
            if (!thisFullScreenPanel.hasClass('open')) {
                $(".ssnail-navigation .navbar-collapse").removeClass("show");
                $(".ssnail-navigation .navbar-toggler").first().addClass("collapsed");
                togglePanelTrigger('open');
                setTimeout(function(){
                    thisFullScreenPanel.find('input').first().focus();
                }, 100);
                changeScrollStatus(false);
            }
            thisFullScreenPanel.addClass('open');
        };
        var close = function() {
            if (thisFullScreenPanel.hasClass('open')) {
                togglePanelTrigger('close');
                changeScrollStatus(true);
            }
            thisFullScreenPanel.removeClass('open');
        };
        var changeScrollStatus = function(enable = true) {
            // https://www.geeksforgeeks.org/how-to-disable-scrolling-temporarily-using-javascript/
            if (enable) {
                window.onscroll = function() {};
            } else {
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                window.onscroll = function() {
                    window.scrollTo(scrollLeft, scrollTop);
                };
            }
        };
        var togglePanelTrigger = function(action) {
            $(".ssnail-fullscreen-panel-trigger").each(function() {
                if (action === 'close') {
                    $(this).removeClass('opened').addClass('closed');
                } else {
                    $(this).addClass('opened').removeClass('closed');
                }
            });
        };

        // public API
        return {
            toggle: toggle,
            open: open,
            close: close
        };
    };

    var ssnailFullScreenPanels = [];

    $(".ssnail-fullscreen-panel").each(function(index, element){
        $(this).attr('data-ssnail-panel-index', index);
        var ssnailFullScreenPanel = new IdrogenoFullScreenPanelClass.run($(this));
        ssnailFullScreenPanels.push(ssnailFullScreenPanel);
    });
    $(".ssnail-fullscreen-panel-trigger").on("click", function(event){
        event.stopPropagation();
        var panelID = $(this).data('ssnail-panel-id');
        var panel = $('#' + panelID).first();
        if (panel.length === 1) {
            var panelIndex = panel.data('ssnail-panel-index');
            if (ssnailFullScreenPanels[panelIndex] !== undefined) {
                ssnailFullScreenPanels[panelIndex].toggle();
            }
        }
    });
    $(window).ready(function () {
        $(".ssnail-navigation .navbar-toggler").on("click", () => {
            ssnailFullScreenPanels.forEach((element) => element.close());
        });
        if ($(".ssnail-fullscreen-panel.to-be-opened").length > 0) {
            $(this).removeClass("to-be-opened");
            var panelIndex = $(this).data('ssnail-panel-index');
            if (ssnailFullScreenPanels[panelIndex] !== undefined) {
                ssnailFullScreenPanels[panelIndex].open();
            }
        }
        $('.ssnail-fullscreen-panel.close-on-click a:not(.prevent-click)').on('click', function(event){
            var panelIndex = $(this).closest('.ssnail-fullscreen-panel').data('ssnail-panel-index');
            if (ssnailFullScreenPanels[panelIndex] !== undefined) {
                ssnailFullScreenPanels[panelIndex].close();
            }
        });
    });
} )( jQuery );
